import { render } from "./CartTag.vue.ts?vue&type=template&id=045b61d7&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CartTag.vue?vue&type=template&id=045b61d7&scoped=true&ts=true"
import script from "./CartTag.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CartTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartTag.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CartTag.vue?vue&type=script&lang=ts&setup=true"

import "./CartTag.vue.scss?vue&type=style&index=0&id=045b61d7&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CartTag.vue?vue&type=style&index=0&id=045b61d7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045b61d7"],['__file',"src/apps/merchant3/components/CartTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "045b61d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('045b61d7', __exports__)) {
    api.reload('045b61d7', __exports__)
  }
  
  module.hot.accept("./CartTag.vue.ts?vue&type=template&id=045b61d7&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CartTag.vue?vue&type=template&id=045b61d7&scoped=true&ts=true", () => {
    api.rerender('045b61d7', render)
  })

}


export default __exports__